/**
* @desc: 弹窗·商务合作
* @author: zengtiansheng
* @update: 2018/3/17
*/
<style lang="less" scoped>
  .dialog-title{
    margin-left: 10px;
  }
  .dialog-content{
    margin-left: 10px;
    color: #9C9C9C;
    font-size: 14px;
  }
  .content-footer{
    text-align: right;
  }
</style>
<template>
  <el-dialog
    v-show="dialogVisible"
    :visible.sync="dialogVisibleShow"
    width="520px">
    <div slot="title" class="dialog-title">
      <p style="font-size: 20px">接入申请</p>
      <span style="font-size: 12px; color: #9C9C9C">
        提交申请我们的工作人员将会在1-3个工作日内联系您
      </span>
    </div>
    <div class="dialog-content">
      <div class="content-form">
        <el-form :model="formData" :rules="formRules" label-width="94px" label-position="left" ref="formRef">
          <el-form-item prop="name">
            <span style="color: #9C9C9C" slot="label">姓名/公司</span>
            <el-input style="width: 305px"
                      placeholder="请填写您的姓名或公司名称"
                      :maxlength="20"
                      v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item prop="mobile">
            <span style="color: #9C9C9C" slot="label">电话</span>
            <el-input style="width: 305px"
                      placeholder="请填写您的联系电话"
                      v-model="formData.mobile"
                      :maxlength="20"
                      onkeypress="return (event.keyCode>=48&&event.keyCode<=57)"></el-input>
          </el-form-item>
          <el-form-item prop="remark">
            <span style="color: #9C9C9C" slot="label">留言</span>
            <el-input type="textarea"
                      :rows="4"
                      style="width: 305px"
                      placeholder="请简单描述您的合作意向"
                      v-model="formData.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content-footer">
      <el-button type="primary" @click="btnCloseDialogClick" plain>取消</el-button>
      <el-button type="primary" :loading="btnLoadingFlag" @click="btnSubmitClick">提交申请</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {dialogMixin} from 'src/mixin/index'
  import {validateNunber} from 'src/libs/formRules'
  import API from '../API'

  export default {
    mixins: [dialogMixin],
    data() {
      return {
        formData: {
          name: '',
          mobile: '',
          remark: ''
        },
        formRules: {
          name: [
            {required: true, message: '请填写姓名或公司名称', trigger: 'blur'},
            { min: 0, max: 20, message: '姓名或公司名称过长', trigger: 'blur' }
          ],
          mobile: [
            {required: true, message: '请填写联系方式', trigger: 'blur'},
            validateNunber({message: '请正确填写联系方式'})
          ],
          remark: [
            {required: true, message: '请简单描述您的合作意向', trigger: 'blur'},
            { min: 0, max: 100, message: '留言内容限定100个字符', trigger: 'change' }
          ]
        },
        btnLoadingFlag: false
      }
    },
    methods: {
      async btnSubmitClick() {
        this.validateForm('formRef', async() => {
          this.btnLoadingFlag = true
          const res = await this.$axios(API.cooperationSave, this.formData)
          this.btnLoadingFlag = false
          if (res.success) {
            this.formData = {
              name: '',
              mobile: '',
              remark: ''
            }
            this.$emit('update:dialogVisible', false)
            this.$message({type: 'success', message: '申请成功，将会在1-3个工作日内联系您'})
          }
        })
      },
      btnCloseDialogClick() {
        this.$emit('update:dialogVisible', false)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/home/modules/dialogCooperation.vue